module.exports = __webpack_public_path__ + "h5/img/nankai.27cbfef8.png";